var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03931 4.2939C3.01461 4.10866 3.07922 3.92338 3.23145 3.81499C3.92732 3.31953 6.31432 2 12.0001 2C17.6859 2 20.0729 3.31952 20.7688 3.81499C20.921 3.92338 20.9856 4.10866 20.9609 4.2939L19.2617 17.0378C19.0969 18.2744 18.3645 19.3632 17.2814 19.9821L16.9615 20.1649C13.8872 21.9217 10.113 21.9217 7.03873 20.1649L6.71885 19.9821C5.63572 19.3632 4.90337 18.2744 4.7385 17.0378L3.03931 4.2939Z",
    stroke: "#21272A",
    strokeWidth: 1.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5C5.57143 7.66666 18.4286 7.66662 21 5",
    stroke: "#21272A",
    strokeWidth: 1.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.7e14da8f81eb7c8d74f0ecc4286d7783.svg";
export { ForwardRef as ReactComponent };